import qs from 'qs';

export const hashToObject = (hash: string) => qs.parse(hash.startsWith('#') ? hash.slice(1) : hash);

export const objectToHash = (obj: Record<string, unknown>) => `#${qs.stringify(obj)}`;

export const getHashParam = (hash: string, key: string) => hashToObject(hash)[key] ?? undefined;

export const setHashParam = (hash: string, key: string, value: unknown) => objectToHash({ ...hashToObject(hash), ...{ [key]: value } });

export const removeHashParam = (hash: string, key: string) => {
    const obj = hashToObject(hash);

    delete obj[key];

    return objectToHash(obj);
};

export const getWindowHashParam = (key: string) => getHashParam(window.location.hash, key);

export const setWindowHashParam = (key: string, value: unknown) => {
    window.location.hash = setHashParam(window.location.hash, key, value);
};

export const removeWindowHashParam = (key: string) => {
    window.location.hash = removeHashParam(window.location.hash, key);
};

export const setUrlHashParam = (url: string, key: string, value: unknown) => {
    const objectUrl = new URL(url, window.location.origin);

    objectUrl.hash = setHashParam(objectUrl.hash, key, value);

    return objectUrl.toString().replace(window.location.origin, '');
};
